import BigNumber from 'bignumber.js'

import { Duration } from '@blade/std-lib'

import type { UserTradingAnalyticsAnalysisDto } from '@root/shared/api/TradeApi'

interface UserTradingAnalyticsAnalysisValue {
  native: BigNumber
  usd: BigNumber
}

export interface UserTradingAnalyticsAnalysis {
  txs: {
    buys: number
    sells: number
  }
  avgHold: Duration.Duration
  balance: UserTradingAnalyticsAnalysisValue
  cost: UserTradingAnalyticsAnalysisValue
  avgCost: UserTradingAnalyticsAnalysisValue
  avgSold: UserTradingAnalyticsAnalysisValue
  avgRealizedProfits: UserTradingAnalyticsAnalysisValue
  fees: UserTradingAnalyticsAnalysisValue
  volume: UserTradingAnalyticsAnalysisValue
  // trackedCount: number
  // renamedCount: number
}

const valueFromDto = (dto: {
  native: string
  usd: string
}): UserTradingAnalyticsAnalysisValue => ({
  native: BigNumber(dto.native),
  usd: BigNumber(dto.usd),
})

export const fromDto = (
  dto: UserTradingAnalyticsAnalysisDto,
): UserTradingAnalyticsAnalysis => {
  return {
    txs: {
      buys: dto.txs.buys,
      sells: dto.txs.sells,
    },
    avgHold: Duration.seconds(dto.avgHoldSeconds),
    balance: valueFromDto(dto.balance),
    cost: valueFromDto(dto.cost),
    avgCost: valueFromDto(dto.avgCost),
    avgSold: valueFromDto(dto.avgSold),
    avgRealizedProfits: valueFromDto(dto.avgRealizedProfits),
    fees: valueFromDto(dto.fees),
    volume: valueFromDto(dto.volume),
    // trackedCount: dto.trackedCount,
    // renamedCount: dto.renamedCount,
  }
}
